export const merchantConstants = {
   ADD_MERCHANT_REQUEST: 			        'ADD_MERCHANT_REQUEST',
   ADD_MERCHANT_SUCCESS: 			        'ADD_MERCHANT_SUCCESS',
   ADD_MERCHANT_FAILURE: 			        'ADD_MERCHANT_FAILURE',
   ADD_MERCHANT_LOCATION_REQUEST:        'ADD_MERCHANT_LOCATION_REQUEST',
   ADD_MERCHANT_LOCATION_SUCCESS:        'ADD_MERCHANT_LOCATION_SUCCESS',
   ADD_MERCHANT_LOCATION_FAILURE:        'ADD_MERCHANT_LOCATION_FAILURE',
   ADD_MERCHANT_STORE_REQUEST:           'ADD_MERCHANT_STORE_REQUEST',
   ADD_MERCHANT_STORE_SUCCESS:           'ADD_MERCHANT_STORE_SUCCESS',
   ADD_MERCHANT_STORE_FAILURE:           'ADD_MERCHANT_STORE_FAILURE',
   GET_MERCHANT_DETAILS_REQUEST:  	     'GET_MERCHANT_DETAILS_REQUEST',
   GET_MERCHANT_DETAILS_SUCCESS:  	     'GET_MERCHANT_DETAILS_SUCCESS',
   GET_MERCHANT_DETAILS_FAILURE:  	     'GET_MERCHANT_DETAILS_FAILURE',
   GET_MERCHANT_LIST_REQUEST:     	     'GET_MERCHANT_LIST_REQUEST',
   GET_MERCHANT_LIST_SUCCESS:     	     'GET_MERCHANT_LIST_SUCCESS',
   GET_MERCHANT_LIST_FAILURE:     	     'GET_MERCHANT_LIST_FAILURE',
   GET_MERCHANT_TYPE_LIST_REQUEST: 	     'GET_MERCHANT_TYPE_LIST_REQUEST',
   GET_MERCHANT_TYPE_LIST_SUCCESS: 	     'GET_MERCHANT_TYPE_LIST_SUCCESS',
   GET_MERCHANT_TYPE_LIST_FAILURE: 	     'GET_MERCHANT_TYPE_LIST_FAILURE',
   DELETE_MERCHANT_REQUEST:              'DELETE_MERCHANT_REQUEST',
   DELETE_MERCHANT_SUCCESS:              'DELETE_MERCHANT_SUCCESS',
   DELETE_MERCHANT_FAILURE:              'DELETE_MERCHANT_FAILURE',
   GET_MERCHANT_LOCATION_DETAILS_REQUEST:'GET_MERCHANT_LOCATION_DETAILS_REQUEST',
   GET_MERCHANT_LOCATION_DETAILS_SUCCESS:'GET_MERCHANT_LOCATION_DETAILS_SUCCESS',
   GET_MERCHANT_LOCATION_DETAILS_FAILURE:'GET_MERCHANT_LOCATION_DETAILS_FAILURE',
   GET_MERCHANT_STORE_DETAILS_REQUEST:   'GET_MERCHANT_STORE_DETAILS_REQUEST',
   GET_MERCHANT_STORE_DETAILS_SUCCESS:   'GET_MERCHANT_STORE_DETAILS_SUCCESS',
   GET_MERCHANT_STORE_DETAILS_FAILURE:   'GET_MERCHANT_STORE_DETAILS_FAILURE',
   UPDATE_MERCHANT_REQUEST:              'UPDATE_MERCHANT_REQUEST',
   UPDATE_MERCHANT_SUCCESS:              'UPDATE_MERCHANT_SUCCESS',
   UPDATE_MERCHANT_FAILURE:              'UPDATE_MERCHANT_FAILURE',
   UPDATE_MERCHANT_STOREFRONT_REQUEST:   'UPDATE_MERCHANT_STOREFRONT_REQUEST',
   UPDATE_MERCHANT_STOREFRONT_SUCCESS:   'UPDATE_MERCHANT_STOREFRONT_SUCCESS',
   UPDATE_MERCHANT_STOREFRONT_FAILURE:   'UPDATE_MERCHANT_STOREFRONT_FAILURE',
   DELETE_MERCHANT_LOCATION_REQUEST:     'DELETE_MERCHANT_LOCATION_REQUEST',
   DELETE_MERCHANT_LOCATION_SUCCESS:     'DELETE_MERCHANT_LOCATION_SUCCESS',
   DELETE_MERCHANT_LOCATION_FAILURE:     'DELETE_MERCHANT_LOCATION_FAILURE',
   DELETE_MERCHANT_STORE_REQUEST:        'DELETE_MERCHANT_STORE_REQUEST',
   DELETE_MERCHANT_STORE_SUCCESS:        'DELETE_MERCHANT_STORE_SUCCESS',
   DELETE_MERCHANT_STORE_FAILURE:        'DELETE_MERCHANT_STORE_FAILURE',
   GET_DEFAULT_TAX_REQUEST:              'GET_DEFAULT_TAX_REQUEST',
   GET_DEFAULT_TAX_SUCCESS:              'GET_DEFAULT_TAX_SUCCESS',
   GET_DEFAULT_TAX_FAILURE:              'GET_DEFAULT_TAX_FAILURE',
   GET_LAT_LONG_REQUEST:                 'GET_LAT_LONG_REQUEST',
   GET_LAT_LONG_SUCCESS:                 'GET_LAT_LONG_SUCCESS',
   GET_LAT_LONG_FAILURE:                 'GET_LAT_LONG_FAILURE',
   UPDATE_MERCHANT_LOGO_REQUEST:         'UPDATE_MERCHANT_LOGO_REQUEST',
   UPDATE_MERCHANT_LOGO_SUCCESS:         'UPDATE_MERCHANT_LOGO_SUCCESS',
   UPDATE_MERCHANT_LOGO_FAILURE:         'UPDATE_MERCHANT_LOGO_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/merchantConstants.js